import { Label } from "@/components/ui/label";
import { ComponentProps, ReactNode } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";

type SelectProps = ComponentProps<typeof Select> & {
  label?: string;
  error?: string;
  className?: string;
  size?: "default" | "sm";
  placeholder?: ReactNode;
  /**
   * Optional `data-testid` forwarded to the underlying Radix
   * `<SelectTrigger>` so E2E specs can target a specific Select on a page
   * with multiple comboboxes (e.g. /user/settings/preferences).
   */
  "data-testid"?: string;
  selectItem: {
    value: string;
    label: string;
  }[];
};

const SelectField = ({ ...props }: SelectProps) => {
  return (
    <div className={`flex w-full flex-col gap-3 ${props.className}`}>
      {props.label && <Label>{props.label}</Label>}
      <div className="flex w-full flex-col gap-1">
        <Select
          name={props.name}
          value={props.value}
          onValueChange={props.onValueChange}
          onOpenChange={props.onOpenChange}
          disabled={props.disabled}
        >
          <SelectTrigger
            size={!props.size ? "default" : props.size}
            className="w-full"
            aria-invalid={!!props.error}
            data-testid={props["data-testid"]}
          >
            <SelectValue placeholder={props.placeholder} />
          </SelectTrigger>
          <SelectContent>
            {props.selectItem.map((item, i) => {
              return (
                <SelectItem
                  key={i}
                  hidden={item.value === "pleaseSelect"}
                  value={item.value}
                >
                  {item.label}
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
        {props.error && (
          <span className="text-destructive pl-1 text-sm">{props.error}</span>
        )}
      </div>
    </div>
  );
};

export default SelectField;
